import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import * as services from "../../services/saleng";
import toast from "react-hot-toast";

const CategoryFormDialog = ({
  open,
  onClose,
  onSuccess,
  initialData,
}) => {
  const isEdit = Boolean(initialData);
  const [name, setName] = useState("");

  useEffect(() => {
    if (!initialData) return;
    setName(initialData.name);
  }, [initialData]);

  const handleConfirm = async () => {
    const trimmed = name.trim();

    try {
      if (isEdit) {
        await services.editCategory({ name: trimmed }, initialData.id);
        toast.success("แก้ไขหมวดหมู่เรียบร้อย");
      } else {
        await services.createCategory({ name: trimmed });
        toast.success("เพิ่มหมวดหมู่เรียบร้อย");
      }
      setName("");
      onSuccess();
      onClose();
    } catch (err) {
      toast.error("เกิดข้อผิดพลาด");
      console.error(err);
    }
  };

  const handleClose = async () => {
    setName("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isEdit ? "แก้ไขหมวดหมู่สินค้า" : "เพิ่มหมวดหมู่สินค้า"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <TextField
            label="ชื่อหมวดหมู่สินค้า"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            helperText="กรอกชื่อหมวดหมู่ เช่น เหล็ก, ไม้, สี"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>ยกเลิก</Button>
        <Button onClick={handleConfirm} variant="contained" color="success">
          {isEdit ? "บันทึกการแก้ไข" : "เพิ่มหมวดหมู่"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryFormDialog;
